import { cva } from '@/styled-system/css';

export const comboboxAdornmentRecipe = cva({
  base: {
    'display': 'inline-flex',
    'justifyContent': 'center',
    'alignItems': 'center',
    'flexShrink': 0,
    'width': 'icon.md',
    'height': 'icon.md',

    '& [data-c11n-component="Icon"]': {
      color: 'Combobox.Adornment.icon.trailing.default',
    },
  },
  variants: {
    size: {
      sm: {
        marginInlineStart: 'tighter',
      },
      md: {
        marginInlineStart: 'tighter',
      },
      lg: {
        marginInlineStart: 'tighter',
      },
    },
  },
});
